import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import SoftButton from "../../../components/SoftButton";
import SoftBox from "../../../components/SoftBox";
import FormProvider from "../../../components/FormProviders";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetSettings, useUpdateSettings } from "../hooks";
import GeneralSettingsForm from "./GeneralSettingsForm";
import { defaultValues, schema } from "../schemas/settingsForm";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const GenerateSettings = ({ brandId }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  // form provider
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onChange",
  });
  const { handleSubmit, reset } = methods;
  const { data: settings } = useGetSettings(brandId);

  // hooks
  const { mutate, isLoading } = useUpdateSettings(brandId);

  // create a function that handles the form submission
  const onSubmit = async ({ expiresIn, merchantSpecificText, thankYouMessage, welcomeMessage }) => {
    const payload = {
      expiresIn: expiresIn ? Number(expiresIn) : null,
      merchantSpecificText,
      thankYouMessage,
      welcomeMessage,
    };
    await mutate(
      { brandId, payload },
      {
        onSuccess: () => {
          handleCloseModal();
        },
      }
    );
  };
  useEffect(() => {
    if (settings) {
      reset(settings);
    }
  }, [settings, isOpenModal]);
  const handleOpenModal = () => {
    setIsOpenModal(true);
  };
  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  return (
    <>
      <SoftBox pt={2} px={2} mb={3}>
        <Stack spacing={1} direction="row" justifyContent="flex-end">
          <SoftButton variant="gradient" color="info" size="small" onClick={handleOpenModal}>
            Settings <SettingsOutlinedIcon />
          </SoftButton>
        </Stack>
      </SoftBox>
      <Dialog open={isOpenModal} onClose={handleCloseModal} fullWidth maxWidth="lg">
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Generate General Settings</DialogTitle>
          <DialogContent>
            <SoftBox p={3} pb={0}>
              <GeneralSettingsForm settingsForm methods={methods} />
            </SoftBox>
          </DialogContent>
          <DialogActions
            sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px" }}
          >
            <SoftButton variant="gradient" onClick={handleCloseModal}>
              Cancel
            </SoftButton>
            <SoftButton variant="gradient" color="info" type="submit" isLoading={isLoading}>
              Save Settings
            </SoftButton>
          </DialogActions>
        </FormProvider>
      </Dialog>
    </>
  );
};

export default GenerateSettings;

GenerateSettings.propTypes = {
  brandId: PropTypes.string,
};
